export class GroupItemLabel {
	id?: number;
	label?: string;

	constructor(init?: Partial<GroupItemLabel>) {
		Object.assign(this, init);
	}
}

export class WarehouseArticleResumee {
	warehouse?: GroupItemLabel;
	color?: GroupItemLabel;
	sizes?: GroupItemLabel[];

	constructor(init?: Partial<WarehouseArticleResumee>) {
		Object.assign(this, init);
	}
}
